<template>
    <div class="flexcol-fill overflow-hidden justify-center">
        <v-container class="border-light border-sm border-opacity-100 pa-5">
            <div class="mb-2">
                Anmelden bei FAMILIOX
            </div>
            <v-text-field v-model="model.Username" :disabled="isBusy" label="E-Mail-Adresse"/>
            <v-text-field v-model="model.Password" :disabled="isBusy" label="Kennwort" type="password"/>
            <f-api ref="api"/>
            <v-btn color="primary" block @click="login" :loading="isBusy" size="x-large"><v-icon icon="mdi-login" class="mr-2"/>Login</v-btn>
        </v-container>
    </div>
</template>
<script>
export default {
  name: 'f-login',
  data() {
    return {
        isBusy: false,
        model: {
            Username: '',
            Password: ''
        }
    }
  },
  methods: {
    login() {
        const vm = this;
        vm.isBusy = true;
        vm.$refs.api.post('auth/token', vm.model, result => {            
            vm.isBusy = false;
            vm.$store.state.account = result;
            window.localStorage.setItem('account', JSON.stringify(result));
        }, () => {
            vm.isBusy = false;
        });
    }
  }
}
</script>
<style lang="css" scoped>
</style>